/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveBarangayPosition, onClose, isEdit, selectedBarangayPosition } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			let params = Object.assign({}, values, { barangay_uid })
			if (isEdit && selectedBarangayPosition) {
				params = Object.assign({}, params, { barangay_position_uid: selectedBarangayPosition.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_brgy_position', content: 'Saving Barangay Position, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayPosition(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_position', content: 'Barangay position successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay position')
					message.error({ key: 'set_brgy_position', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedBarangayPosition } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Add Barangay Positions"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Position Name'>
							{ getFieldDecorator('name', {
								initialValue: (selectedBarangayPosition) ? selectedBarangayPosition.name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter position name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Description'>
							{ getFieldDecorator('description', {
								initialValue: (selectedBarangayPosition) ? selectedBarangayPosition.description : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter position description'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Max Count'>
							{ getFieldDecorator('max_count', {
								initialValue: (selectedBarangayPosition) ? selectedBarangayPosition.max_count : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Input type='number' />
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_POSITION = gql`
    mutation setBarangayPosition($input: JSON) {
		setBarangayPosition(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-term' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_POSITION, {
		props({ mutate }) {
			return {
				saveBarangayPosition(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayPositions']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
